import { useEffect, useState } from "react";
import { FeatureContext } from "../../../Context";
import { lang, useBfGlobals, useQuery } from "../../../Utils";
import { getEnquiryDetails } from "../Services";
import { ChakraProvider, Grid } from '@chakra-ui/react';
import Loader from "../../../components/loader/Loader";
import Details from "./Details";
import Left from "./Left";
import { Error } from "../../../components/error/Error";
import { NoDataFound } from '../../../ErrorType';

const Index = ({ attributes }) => {
  const qs = useQuery();
  const globals = useBfGlobals();
  
  const [state, setState] = useState({
    loader: false,
    error: '',
    details: {},
    comments: [],
    attachments: [],
    setDetails: (value) => setState(prevState => ({ ...prevState, details: value })),
    setComments: (value) => setState(prevState => ({ ...prevState, comments: value })),
    setAttachments: (value) => setState(prevState => ({ ...prevState, attachments: value })),
    setLoader: {
      on: () => setState(prevState => ({ ...prevState, loader: true })),
      off: () => setState(prevState => ({ ...prevState, loader: false })),
    },
    setError: (value) => setState(prevState => ({ ...prevState, error: value })),
  });

  useEffect(() => {

    state.setLoader.on();

    getEnquiryDetails(qs.get('enquiryId'))
      .then(data => {
        state.setDetails(data?.data?.enquiry);
        state.setComments(data?.data?.comments);
        state.setAttachments(data?.data?.attachments);
      })
      .catch(error => {
        if (!(error instanceof NoDataFound)) {
          state.setError(error);
        }
      })
      .finally(_ => state.setLoader.off());
  }, []);


  const render = () => {
    if (!!state.error) {
      return <Error error={state.error}/>
    } else {
      return <div className="bf-enquiry-wrapper">
        <a className="bf-link" href={globals.get('links.enquiry')}>{'< ' + lang('Back')}</a>
        <h2>{state?.details?.subject}</h2>
        <div className="bf-enquiry-container">
          <Details />
          <Left />
        </div>
      </div>
    }
  }

  return <ChakraProvider>
    <FeatureContext.Provider value={state}>
      {(state.loader) ? <Loader /> : render()}
    </FeatureContext.Provider>
  </ChakraProvider>
}

export { Index }